import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { View, Text } from '@react-pdf/renderer';
const EmptyCard = ({ noSelectedItemsLabel }) => (_jsx(View, { style: { padding: '8px 16px', flexDirection: 'column', justifyContent: 'center' }, children: _jsx(Text, { style: { fontSize: '14px', letterSpacing: '0.5px' }, children: noSelectedItemsLabel }) }));
export default EmptyCard;
